export default __webpack_public_path__ + "static/ghost_jolly-53ca29a561b01090440a1a662b29aa61.svg";